module.exports = __webpack_public_path__ + "img/GMOS6-2.5ab3a8c9.png";